import { combineReducers } from 'redux';
import currentUser from './current-user';
import isAuthenticated from './is-authenticated';

export default combineReducers({
  currentUser,
  isAuthenticated,
});
